export default {
  SET: 'set',
  CLEAR: 'clear',
};
